import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Text from "antd/lib/typography/Text";

const quillModulesArticleBody = {
	toolbar: [
		[{ header: [1, 2, 3, 4, 5, 6, false] }],
		[{ size: ["small", false, "large", "huge"] }],
		["blockquote", "code-block"],
		["bold", "italic", "underline", "strike"],
		["link", "image", "video"],
		[{ color: [] }, { background: [] }],
		[{ font: [] }],
		[{ align: [] }],
		[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
		["clean"],
	],
};

const quillModulesDefault = {
	toolbar: [
		[{ header: [1, 2, false] }],
		["bold", "italic", "underline"],
		[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
		["clean"],
	],
};

const quillFormats = [
	"header",
	"size",
	"bold",
	"italic",
	"underline",
	"list",
	"bullet",
	"strike",
	"link",
	"image",
	"video",
	"color",
	"font",
	"background",
	"align",
	"blockquote",
	"code-block",
];

type Props = {
	mode?: "article-body" | "default";
	label?: string;
	value?: string;
	onChange: (val: string) => void;
	_reactQuill?: any;
	style?: React.CSSProperties;
};

export function QuillEditor({ mode, label, value, onChange, _reactQuill, style }: Props) {
	return (
		<React.Fragment>
			{!!label && <Text style={{ fontWeight: "bold" }}>{label}</Text>}
			<ReactQuill
				style={{ marginBottom: 20, marginTop: label ? 5 : 0, ...style }}
				theme="snow"
				value={value}
				onChange={(val) => {
					onChange(val);
				}}
				modules={
					_reactQuill?.modules
						? _reactQuill.modules
						: mode === "article-body"
						? quillModulesArticleBody
						: quillModulesDefault
				}
				formats={quillFormats}
				{...(_reactQuill ?? {})}
			/>
		</React.Fragment>
	);
}
